/** Inclusive calendar-day count between two YYYY-MM-DD strings (local date semantics). */
export function inclusiveDayCount(startYmd, endYmd) {
  if (!startYmd || !endYmd) return null;
  const [ys, ms, ds] = startYmd.split("-").map(Number);
  const [ye, me, de] = endYmd.split("-").map(Number);
  const start = new Date(ys, ms - 1, ds);
  const end = new Date(ye, me - 1, de);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return null;
  const diffMs = end.getTime() - start.getTime();
  return Math.round(diffMs / 86400000) + 1;
}

export const GAS_PERIOD_MIN_DAYS = 30;
/** Upper bound for “12 months” (covers leap-year February). */
export const GAS_PERIOD_MAX_DAYS = 366;

/**
 * @returns {{ ok: true, days: number } | { ok: false, message: string }}
 */
export function validateGasBillingPeriod(startYmd, endYmd) {
  if (!startYmd || !endYmd) {
    return { ok: false, message: "Select both a start date and an end date for gas use." };
  }
  const days = inclusiveDayCount(startYmd, endYmd);
  if (days === null) {
    return { ok: false, message: "Enter valid dates for the gas billing period." };
  }
  if (days < 1) {
    return { ok: false, message: "The end date must be on or after the start date." };
  }
  if (days < GAS_PERIOD_MIN_DAYS) {
    return {
      ok: false,
      message: `The period must be at least ${GAS_PERIOD_MIN_DAYS} days (inclusive).`,
    };
  }
  if (days > GAS_PERIOD_MAX_DAYS) {
    return {
      ok: false,
      message: `The period must be at most 12 months (${GAS_PERIOD_MAX_DAYS} inclusive days).`,
    };
  }
  return { ok: true, days };
}

/** Minimum gas volume (m³) hinted from the legacy 250 m³/year floor, scaled by period length. */
export function minGasUseForPeriod(days) {
  if (!days || days < 1) return 10;
  return Math.max(10, Math.floor((250 * days) / GAS_PERIOD_MAX_DAYS));
}
